import {
  MUNICIPALITY_FEATURES,
  REGION_FEATURES,
} from '@schema/featureToggle'

export const regionsTabsQueryParamName = 'tab'
export const regionalActueelTabsQueryParamName = 'actueelTab'

export const regionTabs = REGION_FEATURES
export const municipalityTabs = MUNICIPALITY_FEATURES

/** Tabs shown in the geography page layout sticky navbar (region) */
export const regionalPageLayoutTabs = {
  home: regionTabs.overview,
  current: regionTabs.current,
  discussion: regionTabs.discussion,
  initiatives: regionTabs.initiatives,
  municipalities: regionTabs.municipalities,
  experts: regionTabs.experts,
  knowledgeHub: regionTabs.knowledgeHub,
} as const

/** Tabs shown in the geography page layout sticky navbar (municipality) */
export const municipalityPageLayoutTabs = {
  home: municipalityTabs.overview,
  current: municipalityTabs.current,
  discussion: municipalityTabs.discussion,
  initiatives: municipalityTabs.initiatives,
  locations: municipalityTabs.locations,
  stepByStep: municipalityTabs.stepByStep,
  experts: municipalityTabs.experts,
  knowledgeHub: municipalityTabs.knowledgeHub,
} as const

export const regionalActueelTabs = {
  verhalen: 'verhalen',
  news: 'news',
  blog: 'blog',
} as const
